import bem from 'utils/bem';

export const block = bem('episode-creation-method-select-modal');
